import { ReactSVG } from "react-svg";

import { TenantUserRow } from "services/api/tenants/types";
import UserCell from "ui/components/Table/TableSearch/components/Cells/UserCell";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const TENANT_USER_COLUMNS = (
  handleDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "Korisnik",
    field: "firstName",
    type: ColumnTypes.custom,
    render: (row: TenantUserRow) => (
      <UserCell
        fullName={[row.firstName, row.lastName].filter(Boolean).join(" ")}
        userId={row.id}
        email={row.email}
      />
    ),
  },
  {
    title: "Email",
    field: "email",
    type: ColumnTypes.custom,
    render: (row: TenantUserRow) => (
      <span className="text-sm text-slate-900">{row.email}</span>
    ),
  },
  {
    title: "Uloge",
    field: "roles",
    type: ColumnTypes.custom,
    render: (row: TenantUserRow) =>
      row.roles?.length > 0 ? (
        <span className="text-sm text-slate-500">
          {row.roles.map((role) => role.name).join(", ")}
        </span>
      ) : (
        <span className="text-sm text-slate-400">Bez uloge</span>
      ),
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: TenantUserRow) => (
      <div
        onClick={(e) => handleDeleteClick(e, row.id)}
        className="flex justify-end items-center h-[30px] cursor-pointer"
      >
        <ReactSVG src="/media/icons/trash.svg" className="w-4 h-4 stroke-[#bd0000]" />
      </div>
    ),
  },
];
